import {Component, Inject, OnInit, signal} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {find} from 'lodash';
import {TranslateModule} from '@ngx-translate/core';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {RequestsService} from '../../../core/requests/requests.service';

@Component({
  selector: 'app-export-drilldown-dialog',
  templateUrl: './export-drilldown-dialog.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    TextFieldComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    InfoMessageComponent
  ]
})
export class ExportDrilldownDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public isLoading = signal(false);
  public error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly cell,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private requestsSvc: RequestsService,
    private dialogRef: MatDialogRef<ExportDrilldownDialogComponent>
  ) {}

  ngOnInit() {
    const activity = find(this.diagramJsonSvc.get().activities, act => act.mxKey === +this.cell.id);
    const text = this.interpolate(activity.text) || '';

    this.form = new UntypedFormGroup({
      mapName: new UntypedFormControl(text, [
        Q9Validators.required(),
        Q9Validators.minLength(2, 'POPUPS.EXPORT_DRILLDOWN_MAP_NAME_LENGTH'),
        Q9Validators.maxLength(60, 'POPUPS.EXPORT_DRILLDOWN_MAP_NAME_LENGTH')
      ])
    });
  }

  get taskForExportDrilldown() {
    return {
      isApi: true,
      method: 'PUT',
      url: `/drilldown/export`,
      data: this.dataForExportDrilldown
    };
  }

  get dataForExportDrilldown() {
    return {
      activityId: Number(this.cell.id),
      diagramVersionId: this.diagramJsonSvc.get().id,
      name: this.form.get('mapName').value,
      sourceMapId: this.diagramJsonSvc.get().map.id,
      team: this.diagramJsonSvc.get().team.id
    };
  }

  public async onSubmit() {
    if (this.form.invalid) {
      return;
    }

    try {
      this.isLoading.set(true);
      const result = await this.requestsSvc.addToQueue(this.taskForExportDrilldown, true);

      this.diagramJsonSvc.update({activityMxKey: this.cell.id, drilldown: result});
      this.dialogRef.close();
    } catch (error) {
      this.handleError(error);
    } finally {
      this.isLoading.set(false);
    }
  }

  public interpolate(string) {
    return string
      .replace(/(<([^>]+)>)/gi, ' ')
      .replace(/&quot;/g, '"')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&#x3D;/g, '=')
      .replace(/&#x60;/g, '`')
      .replace(/&#x2F;/g, '/')
      .replace(/&gt;/g, '>')
      .trim()
      .substring(0, 60);
  }

  private handleError(error) {
    switch (error.error.status) {
      case 'diagram_rights.cannot_edit':

      case 'export_drilldown.no_rights':
        this.error = 'POPUPS.NO_EDIT_ACCESS';
        break;

      case 'export_drilldown.target_diagram_not_exist':
        this.error = 'POPUPS.NO_EDIT_DELETED';
        break;
    }
  }
}
